import { Type } from "@angular/core";
import { IQuestion } from "src/app/interface/filters";
import { DeleteCommand } from "src/app/modules/records/commands/delete-command";
import { TextCol } from "src/app/modules/records/models/columns/text-col";
import { InterviewsService } from "src/app/services/interviews.service";
import { MeUser } from "src/app/services/models/me-user";
import { CreateRecoveryPlanCommand } from "src/app/shared/commands/create-recovery-plan-command";
import { CreateTagOnlineRepCommand } from "src/app/shared/commands/create-tag-onlinerep-command";
import { ConfirmDialogComponent } from "src/app/shared/dialogs/confirm-dialog/confirm-dialog.component";
import { ActionCol } from "src/app/shared/table-col-configs/action-col";
import { RatingColOnlineRep } from "src/app/shared/table-col-configs/rating-onlinerep-col";
import { ActionButtonsComponent } from "src/app/shared/table-components/action-buttons/action-buttons.component";
import { ActionButtonsNoTextComponent } from "src/app/shared/table-components/action-buttons-no-text/action-buttons-no-text.component";
import { DELETE_ACTION_PLAN_DIALOG_CONFIG } from "../../../action-plan/delete-action-plan-dialog-config";
import { CreateCommentOnlineRepCommand } from "src/app/shared/commands/create-comment-onlinerep-command";
import { InterviewsV2Service } from "src/app/services/interviews-v2.service";


export const INTERVIEW_ONLINEREP_COLUMNS_DEFAULT = (user: MeUser, service: InterviewsService | InterviewsV2Service) =>
	[

		new RatingColOnlineRep("responseFlag", "Check Response", undefined),
		new TextCol("dataReview", undefined, "onlineRepInterview.dataReview"),
		new TextCol("responseDate", undefined, "onlineRepInterview.responseDate"),
		new TextCol("dealerId", undefined, "onlineRepInterview.dealer"),
		new TextCol("dealerName", undefined, "onlineRepInterview.dealerName"),
		new TextCol("rating", undefined, "onlineRepInterview.rating"),
		new TextCol("comments", undefined, "onlineRepInterview.comments"),
		new TextCol("response", undefined, "onlineRepInterview.response"),
		//new TextCol("sentiment", undefined, "onlineRepInterview.sentiment"),
		new ActionCol<any, Type<ActionButtonsComponent<any>>, InterviewsService | InterviewsV2Service>(
			"responseCreateBtn",
			false,
			"onlineRepInterview.response",
			[new CreateCommentOnlineRepCommand<any, InterviewsService | InterviewsV2Service>(service)],
			ActionButtonsComponent
		),
		new TextCol("customerId", undefined, "onlineRepInterview.customerId"),
		new TextCol("customerName", undefined, "onlineRepInterview.customerName"),
		//new TextCol("customerEmail", undefined, "onlineRepInterview.customerEmail"),
		//new TextCol("customerConfirmed", undefined, "onlineRepInterview.customerConfirmed"),
		new TextCol("reviewEdited", undefined, "onlineRepInterview.reviewEdited"),
		new TextCol("reviewId", undefined, "onlineRepInterview.reviewId"),
		new TextCol("businessId", undefined, "onlineRepInterview.businessId"),
		new TextCol("sourceType", undefined, "onlineRepInterview.sourceType"),
		new TextCol("marketId", undefined, "onlineRepInterview.market"),
		new TextCol("outletId", undefined, "onlineRepInterview.outlet"),
		new TextCol("agentCode", undefined, "onlineRepInterview.agentCode"),
		new TextCol("brandId", undefined, "onlineRepInterview.brand", undefined, true),
		new TextCol("regionId", undefined, "onlineRepInterview.region"),
		new ActionCol<any, Type<ActionButtonsComponent<any>>, InterviewsService | InterviewsV2Service>(
			"section",
			false,
			"Review Type",
			[new CreateTagOnlineRepCommand<any, InterviewsService | InterviewsV2Service>(service)],
			ActionButtonsComponent
		),
		new ActionCol<any, Type<ActionButtonsComponent<any>>, InterviewsService | InterviewsV2Service>(
			"rpCreateBtn",
			false,
			"hotAlertTable.rpStatus",
			[new CreateRecoveryPlanCommand<any, InterviewsService | InterviewsV2Service>(service)],
			ActionButtonsNoTextComponent
		),

	]